// extracted by mini-css-extract-plugin
export default {"Text":"components-Login-Text-_Text-module_Text","text":"components-Login-Text-_Text-module_Text"};